import { render } from "./TrainingDetail.vue?vue&type=template&id=668721f2&scoped=true"
import script from "./TrainingDetail.vue?vue&type=script&lang=js"
export * from "./TrainingDetail.vue?vue&type=script&lang=js"

import "./TrainingDetail.vue?vue&type=style&index=0&id=668721f2&lang=scss&scoped=true"

import exportComponent from "/Users/hxp/Workspace/bintangmas-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-668721f2"]])

export default __exports__